import { render, staticRenderFns } from "./CCT.vue?vue&type=template&id=36e3fc90&scoped=true&"
import script from "./CCT.vue?vue&type=script&lang=js&"
export * from "./CCT.vue?vue&type=script&lang=js&"
import style0 from "./CCT.vue?vue&type=style&index=0&id=36e3fc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3fc90",
  null
  
)

export default component.exports